import { isUserVATExempt } from "@/helpers/order-pricing";

export default {
    namespaced: true,
    state: {
        checkoutBillingAddressId: null,
    },
    getters: {
        withoutVAT(state, getters, rootState, rootGetters) {
            return isUserVATExempt(rootState.user.user, rootGetters["config/hermesAPI"], state.checkoutBillingAddressId);
        },
    },
    mutations: {
        setCheckoutBillingAddressId(state, addressId) {
            state.checkoutBillingAddressId = addressId;
        },
    },
};